import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

Vue.use(Vuex)

const badMutations = [
  'someMutationThatGetsCalledTooOften'
]

const vuexLocalStorage = new VuexPersist({
  key: 'radionica.v.1',
  storage: window.localStorage,
  // filter: mutation => (badMutations.indexOf(mutation.type) === -1)
})

export default new Vuex.Store({
  state: {
    lang: 'bs',
    notice: true,
  },
  mutations: {
    changeLang (state, payload) {
      state.lang = payload
    },
    closeNotice (state) {
      state.notice = false
    }
  },
  actions: {
  },
  getters: {
    lang: state => {
      return state.lang
    },
    notice: state => {
      return state.notice
    }
  },
  plugins: [vuexLocalStorage.plugin]
})
